import { defineQuery } from '@rocicorp/zero';
import * as z from 'zod';
import { Status, zql } from '../schema.js';
import { applyCursor } from '../util/apply-cursor.js';
import { Cursor, Sort } from './util.js';
export const ProtocolsFilters = z.object({
    search: z.string().optional(),
    diagnosis: z.array(z.uuidv7()).optional(),
    substances: z.array(z.uuidv7()).optional(),
    cancerTypes: z.array(z.uuidv7()).optional(),
    status: z.array(Status).optional(),
});
export const ListProtocolsInput = z.object({
    cursor: Cursor.extend({
        createdAt: z.number(),
        // sortable fields must all be part of the cursor (see context/zero.md)
        name: z.string(),
    }).optional(),
    sort: Sort.extend({
        field: z.enum(['createdAt', 'name']).default('name'),
    }),
    limit: z.number().optional(),
    filters: ProtocolsFilters.optional(),
});
export const protocolsQueries = {
    listProtocols: defineQuery(ListProtocolsInput, params => {
        const input = params.args;
        let q = zql.protocols
            .related('created')
            .related('diagnosis')
            .related('cancerType')
            .related('therapySequence', q => q.where('deletedAt', 'IS', null).related('medicine'))
            .where('deletedAt', 'IS', null);
        if (input?.filters) {
            const { diagnosis, substances, cancerTypes, status } = input.filters;
            const search = input?.filters?.search?.trim();
            if (search) {
                q = q.where('name', 'ILIKE', `%${search}%`);
            }
            if (diagnosis?.length) {
                q = q.where('diagnosisId', 'IN', diagnosis);
            }
            if (cancerTypes?.length) {
                q = q.where('cancerTypeId', 'IN', cancerTypes);
            }
            if (substances?.length) {
                q = q.whereExists('therapySequence', therapySequence => therapySequence.whereExists('medicine', medicine => medicine.where('activeSubstanceId', 'IN', substances)));
            }
            if (status?.length) {
                q = q.where('status', 'IN', status);
            }
        }
        q = applyCursor(q, { cursor: input.cursor, sort: input.sort, limit: input.limit });
        return q;
    }),
    getProtocolById: defineQuery(z.string(), params => {
        return zql.protocols
            .where('id', '=', params.args)
            .related('created')
            .related('diagnosis')
            .related('cancerType')
            .related('therapySequence', q => q.where('deletedAt', 'IS', null).related('medicine'))
            .where('deletedAt', 'IS', null)
            .one();
    }),
    getProtocolActivitiesById: defineQuery(z.string(), params => {
        return zql.eventLogs
            .related('actor')
            .where('resource', '=', 'protocol')
            .where('resourceId', '=', params.args)
            .orderBy('performedAt', 'desc');
    }),
};
//# sourceMappingURL=protocols.queries.js.map